import Alert from '@/components/common/dialog/Alert'
import Confirm from '@/components/common/dialog/Confirm'
import SelectBox from '@/components/common/dialog/SelectBox'
import deferred from 'vue-deferred'
import { defineAsyncComponent } from 'vue'
import { $vfm } from 'vue-final-modal'

export default function() {
  function makeid(length) {
    var result = ''
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  const alert = function(msg) {
    var defer = deferred()
    console.log(defer)
    let dialogId = makeid(9)
    $vfm.show({
      component: 'VDynamicModal',
      bind: {
        name: dialogId,
        'container-class': '',
        'content-class': '',
      },
      on: {
        confirm(close) {
          console.log('confirm')
          close()
        },
        cancel(close) {
          console.log('cancel')
          close()
        },
        // event by vue-final-modal
        'click-outside'() {
          console.log('@click-outside')
          defer.resolve()
        },
        'before-open'() {
          console.log('@before-open')
        },
        opened() {
          console.log('@opened')
        },
        'before-close'() {
          console.log('@before-close')
        },
        closed() {
          console.log('@closed')
        },
      },
      slots: {
        default: {
          component: Alert,
          bind: {
            text: msg,
          },
          on: {
            close() {
              $vfm.hide(dialogId)
              defer.resolve()
            },
          },
        },
      },
    })
    return defer.promise
  }

  const confirm = function(msg) {
    var defer = deferred()
    console.log(defer)
    let dialogId = makeid(9)
    $vfm.show({
      component: 'VDynamicModal',
      bind: {
        name: dialogId,
        'container-class': '',
        'content-class': '',
      },
      on: {
        confirm(close) {
          console.log('confirm')
          close()
        },
        cancel(close) {
          console.log('cancel')
          close()
        },
        // event by vue-final-modal
        'click-outside'() {
          console.log('@click-outside')
          defer.resolve()
        },
        'before-open'() {
          console.log('@before-open')
        },
        opened() {
          console.log('@opened')
        },
        'before-close'() {
          console.log('@before-close')
        },
        closed() {
          console.log('@closed')
        },
      },
      slots: {
        default: {
          component: Confirm,
          bind: {
            text: msg,
          },
          on: {
            close(value) {
              $vfm.hide(dialogId)
              defer.resolve(value)
            },
          },
        },
      },
    })
    return defer.promise
  }

  const select = function(param) {
    var defer = deferred()
    let dialogId = makeid(9)
    $vfm.show({
      component: 'VDynamicModal',
      bind: {
        name: dialogId,
        containerClass: 'type_select',
        contentClass: '',
      },
      on: {
        confirm(close) {
          console.log('confirm')
          close()
        },
        cancel(close) {
          console.log('cancel')
          close()
        },
        // event by vue-final-modal
        'click-outside'() {
          console.log('@click-outside')
          defer.resolve()
        },
        'before-open'() {
          console.log('@before-open')
        },
        opened() {
          console.log('@opened')
        },
        'before-close'() {
          console.log('@before-close')
        },
        closed() {
          console.log('@closed')
        },
      },
      slots: {
        default: {
          component: SelectBox,
          bind: {
            param: param,
          },
          on: {
            select(data) {
              $vfm.hide(dialogId)
              defer.resolve(data)
            },
            close() {
              $vfm.hide(dialogId)
              defer.resolve()
            },
          },
        },
      },
    })
    return defer.promise
  }

  const lyorPop = function(componentName, param, className) {
    var defer = deferred()
    let dialogId = makeid(9)

    $vfm.show({
      component: 'VDynamicModal',
      bind: {
        name: dialogId,
        'container-class': className?.container || '',
        'content-class': className?.content || '',
      },
      on: {
        confirm(close) {
          console.log('confirm')
          close()
        },
        cancel(close) {
          console.log('cancel')
          close()
        },
        // event by vue-final-modal
        'click-outside'() {
          console.log('@click-outside')
          defer.resolve()
        },
        'before-open'() {
          console.log('@before-open')
        },
        opened() {
          console.log('@opened')
        },
        'before-close'() {
          console.log('@before-close')
        },
        closed() {
          console.log('@closed')
        },
      },
      slots: {
        default: {
          component: defineAsyncComponent(() =>
            import('@/components/' + componentName)
          ),
          bind: param,
          on: {
            close(data) {
              $vfm.hide(dialogId)
              defer.resolve(data)
            },
          },
        },
      },
    })
    return defer.promise
  }

  return {
    alert,
    confirm,
    select,
    lyorPop,
  }
}
